import React from 'react'
import { Card, Input, Space, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useDisputes } from '../hooks/useDisputes'
import { useDisputeActions } from '../hooks/useDisputeActions'
import { DisputesTable } from '../components/DisputesTable'
import { DisputeDetailsDrawer } from '../components/DisputeDetailsDrawer'

export const DisputesScreen: React.FC = () => {
    const {
        disputes,
        searchText, setSearchText,
        statusFilter, setStatusFilter,
        priorityFilter, setPriorityFilter
    } = useDisputes()

    const {
        selectedDispute,
        isDetailDrawerOpen,
        handleViewDetails,
        handleAssignDispute,
        handleResolveDispute,
        handleSendMessage,
        closeDrawer
    } = useDisputeActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search disputes..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Select
                        placeholder="Filter by status"
                        style={{ width: 150 }}
                        value={statusFilter}
                        onChange={setStatusFilter}
                    >
                        <Select.Option value="all">All</Select.Option>
                        <Select.Option value="open">Open</Select.Option>
                        <Select.Option value="in_progress">In Progress</Select.Option>
                        <Select.Option value="resolved">Resolved</Select.Option>
                    </Select>
                    <Select
                        placeholder="Filter by priority"
                        style={{ width: 150 }}
                        value={priorityFilter}
                        onChange={setPriorityFilter}
                    >
                        <Select.Option value="all">All</Select.Option>
                        <Select.Option value="critical">Critical</Select.Option>
                        <Select.Option value="high">High</Select.Option>
                        <Select.Option value="medium">Medium</Select.Option>
                    </Select>
                </Space>

                <DisputesTable
                    disputes={disputes}
                    onRowClick={handleViewDetails}
                />
            </Card>

            <DisputeDetailsDrawer
                dispute={selectedDispute}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onAssign={handleAssignDispute}
                onResolve={handleResolveDispute}
                onSendMessage={handleSendMessage}
            />
        </Space>
    )
}
